export default __webpack_public_path__ + "static/media/1.258003c1.svg";